<section>
  <div
    class="is-flex is-justify-content-space-between is-align-items-center mb-5"
  >
    <div class="left-part">
      @switch (mode) {
        @case (ResourceMode.Create) {
          <h1
            class="title is-2 has-text-weight-light"
          >
            Add a {{ definition.nameSingular }}
          </h1>
        }
        @case (ResourceMode.Edit) {
          <h1 class="title is-2 has-text-weight-light">Update a {{ definition.nameSingular }}</h1>
        }
        @default {
          <h1 class="title is-2 has-text-weight-light">Update a {{ definition.nameSingular }}</h1>
        }
      }
    </div>
  </div>

  <app-step-progress-bar
    [steps]="policyInitiativeSteps"
    [currentStep]="currentStep"
    [mode]="mode"
    (stepClicked)="goToStep($event)"
  ></app-step-progress-bar>

  <form [formGroup]="form" *ngIf="form" class="mb-huge">
    <div class="card p-4">
      <!-- Step 0 introduction -->
      <div class="columns">
        <div
          class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd"
        >
          <app-introduction
            [step]="currentStep"
            [isNotConcernedByEvaluation]="
              item?.category !== InitiativeCategory.NationalStrategy
            "
          ></app-introduction>
        </div>
      </div>

      <!-- Fields -->
      <div class="columns">
        <div
          class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd"
        >
          <div class="columns is-multiline is-align-items-flex-end">
            <ng-container *ngFor="let field of resolvedFields">
              <div
                class="column is-12"
                *ngIf="
                  field.id === 'category' &&
                  form?.get('category')?.value ===
                    InitiativeCategory.NationalStrategy
                "
              >
                <app-info-box
                  type="info"
                  title="What is a National AI Strategy ?"
                  [content]="infoBoxContentNationalStrategy"
                ></app-info-box>
              </div>

              <ng-container *caseHasPermission="field.permission">
                <div
                  class="column is-flex is-align-items-flex-end {{
                    field.className || 'is-6'
                  }}"
                  [id]="field.id"
                  *ngIf="!field.hidden"
                >
                  <case-input
                    [id]="field.id"
                    [type]="field.inputType"
                    [label]="field.label"
                    [placeholder]="field.placeholder"
                    [secondPlaceholder]="field.secondPlaceholder"
                    [initialValue]="field.initialValue"
                    [searchResources]="field.searchResources"
                    [filterResource]="field.filter"
                    [groupBy]="field.groupBy"
                    [resourceName]="definition.slug"
                    [searchParams]="field.searchParams"
                    [maxSelectedItems]="field.maxSelectedItems"
                    [selectAllDisabled]="field.selectAllDisabled"
                    [selectOptions]="field.selectOptions"
                    [askFileYear]="field.askFileYear"
                    [min]="field.min"
                    [max]="field.max"
                    [showCreateButton]="field.showCreateButton"
                    [copyDateFromOnDateTo]="field.copyDateFromOnDateTo"
                    [readonly]="field.readonly"
                    [validators]="field.validators"
                    [required]="field.required"
                    [helpText]="field.helpText"
                    [htmlHelpText]="field.htmlHelpText"
                    [htmlTooltip]="field.htmlTooltip"
                    [htmlExample]="field.htmlExample"
                    [showErrors]="showErrors"
                    [isInitiativeTypeFieldError]="isInitiativeTypeFieldError()"
                    (valueChanged)="onValueChanged($event, field)"
                  ></case-input>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="columns">
        <div
          class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd"
        >
        </div>
      </div>

      <!-- Navigation -->
      <div class="columns mt-2 mb-4">
        <div
          class="column is-10-tablet is-offset-1-tablet is-8-desktop is-offset-2-desktop is-6-fullhd is-offset-3-fullhd is-flex is-align-items-flex-end is-justify-content-space-between"
        >
          <a
            [routerLink]="['/policy-initiatives']"
            class="button mr-auto is-white"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="currentStep === 0 || (currentStep === 1 && this.item)"
            >Back to List View</a
          >

          <a
            (click)="goToStep(currentStep - 1)"
            class="button mr-auto is-white"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="
              (this.item && currentStep > 1) || (!this.item && currentStep > 0)
            "
            >Previous</a
          >

          <a
            [routerLink]="['/policy-initiatives', 'create']"
            [queryParams]="{ step: 1 }"
            class="button is-link ml-auto"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="currentStep === 0"
            >Get started</a
          >

          <a
            (click)="
              saveAndGoToStep({
                step: currentStep
              })
            "
            class="button is-link-light mr-6"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="currentStep > 0"
            >Save</a
          >
          <a
            (click)="
              saveAndGoToStep({
                step: currentStep + 1
              })
            "
            class="button is-link"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="currentStep > 0 && currentStep < 3"
            >Save and next</a
          >

          <a
            (click)="submit()"
            class="button is-link"
            [ngClass]="{ 'is-loading': loading }"
            *ngIf="currentStep === 3"
            >Submit</a
          >
        </div>
      </div>
    </div>
  </form>
</section>
